import { getCustomPageByTag } from 'api/std';
import { CUSTOM_PAGE_TAG } from './enums';

export async function updateSiteConfigFromPortalFurnish(
  siteConfig: Partial<SiteConfig>,
  runtimeConfiguration: any,
  options?: FetchOptions,
): Promise<Partial<SiteConfig>> {
  try {
    const enableMallCustomPage = !!runtimeConfiguration.find(
      (item) => item.key === 'enableCustomPage',
    )?.value;
    if (enableMallCustomPage) {
      {
        const res = await getCustomPageByTag(CUSTOM_PAGE_TAG.COMMON, options);
        if (res.code === 200) {
          const { pageSetting } = res.data;
          const header = pageSetting?.header ?? {};
          const footer = pageSetting?.footer ?? {};
          const sider = pageSetting?.sider ?? {};
          const { navigationSetting } = res.data;
          const { portalNavList } = pageSetting;

          if (header.platformMainColor) {
            header.platformMainColor = `#${header.platformMainColor}`;
          }
          siteConfig = {
            ...siteConfig,
            global: {
              ...siteConfig.global,
              ...header,
              ...footer,
              sider,
              navigationSetting,
              portalNavList,
            },
          };
        }
      }
      {
        const res = await getCustomPageByTag(CUSTOM_PAGE_TAG.MALL_INDEX, options);
        if (res.code === 200) {
          const { pageSetting } = res.data;
          const indexConfig = pageSetting?.indexConfig ?? {};

          siteConfig = {
            ...siteConfig,
            global: {
              ...siteConfig.global,
              indexConfig,
            },
          };
        }
      }
    }
  } catch (error) {
    console.log(error);
  }
  return siteConfig;
}
